import { WeekShiftService } from "../../services";
import { createCRUDThunksLegacy } from "../../shared/helpers";
import { IWeekShift, IWeekShiftBase } from "../../shared/types";

const service = new WeekShiftService();

const resourceName = "WeekShifts";

const crudThunks = createCRUDThunksLegacy<IWeekShift, IWeekShiftBase>({
  service,
  resourceName,
});

export const weekShiftThunks = {
  ...crudThunks,
};
